import React from 'react';
import { StyleSheet, TextInput } from 'react-native';

const StyledInput = React.forwardRef((props, ref) => {
  return (
    <TextInput
      ref={ref}
      {...props}
      style={[styles.input, props.style]}
      placeholderTextColor="rgba(255, 255, 255, 0.5)"
    />
  );
});

const styles = StyleSheet.create({
  input: {
    backgroundColor: '#1D1E22',
    borderWidth: 1,
    borderColor: '#373737',
    borderRadius: 12,
    padding: 16,
    fontFamily: 'Satoshi-Medium',
    fontSize: 14,
    color: '#FFFFFF',
    shadowColor: 'rgba(10, 13, 18, 0.05)',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 1,
    shadowRadius: 2,
    elevation: 2,
  },
});

export default StyledInput;
